import { render, staticRenderFns } from "./ownOrderPay.vue?vue&type=template&id=1084e0fa&scoped=true&"
import script from "./ownOrderPay.vue?vue&type=script&lang=js&"
export * from "./ownOrderPay.vue?vue&type=script&lang=js&"
import style0 from "./ownOrderPay.vue?vue&type=style&index=0&id=1084e0fa&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1084e0fa",
  null
  
)

export default component.exports